var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import Select from 'react-select';
import styled, { useTheme } from 'styled-components';
import Label from '../Label/Label';
import Error from '../Error/Error';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
const SelectContainer = styled.div `
  position: relative;
  top: ${props => props.isLoading ? props.theme.paddingsMargins.themeMenuMarginSingle : '0'};
  margin-bottom: ${props => props.isLoading ? '1.5rem' : props.theme.spacings.halfSpacing};
  width: 100%;
  font-family: ${props => props.theme.fonts.fontFamily};
`;
const MultiSelect = forwardRef((_a, ref) => {
    var { options, name, errors = {}, label, labelSize = 'article', textSize = 'article', onChange = () => { }, onInputChange = () => { }, placeholder = '', value, color = 'main', labelColor, isLoading = false, isLoadingLabel = false, menuPlacement, skeleton, skeletonLabel, isDisabled = false, excludeMeFromLoadingContext = false } = _a, props = __rest(_a, ["options", "name", "errors", "label", "labelSize", "textSize", "onChange", "onInputChange", "placeholder", "value", "color", "labelColor", "isLoading", "isLoadingLabel", "menuPlacement", "skeleton", "skeletonLabel", "isDisabled", "excludeMeFromLoadingContext"]);
    const theme = useTheme();
    const menuStyles = {
        control: (styles, { isFocused }) => theme.utils.getControlStyle(styles, isFocused, color, textSize, theme),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => theme.utils.getOptionStyle(styles, isDisabled, isFocused, isSelected, color, textSize, theme),
        placeholder: (styles) => theme.utils.getPlaceholderStyle(styles, textSize, theme),
        input: (styles) => (Object.assign({}, styles)),
        menuPortal: (styles) => theme.utils.getMenuPortal(styles),
        menu: (styles) => (Object.assign(Object.assign({}, styles), { fontFamily: theme.fonts.fontFamily, '& input': {
                font: 'inherit'
            } })),
        singleValue: (styles) => theme.utils.getSingleValue(styles, color, textSize),
        multiValue: (styles) => theme.utils.getMultiValue(styles, color, isDisabled, theme),
        multiValueLabel: (styles) => theme.utils.getMultiValueLabel(styles, textSize, theme),
        multiValueRemove: (styles) => theme.utils.getMultiValueRemove(styles, color, theme)
    };
    const { loadingContext } = useCronoSkeleton();
    return (_jsxs(SelectContainer, Object.assign({ isLoading: ((loadingContext && excludeMeFromLoadingContext === false) || isLoading) ? 'true' : '' }, props, { children: [!!label &&
                _jsx(Label, { isDisabled: isDisabled, label: label, labelSize: labelSize, color: labelColor || color, isLoading: isLoadingLabel && ((loadingContext && excludeMeFromLoadingContext === false) || isLoading), skeleton: skeletonLabel }), (loadingContext && excludeMeFromLoadingContext === false) || isLoading
                ? _jsx(Skeleton, Object.assign({ height: "title", margin: "v" }, skeleton))
                : _jsx(Select, { isDisabled: isDisabled, isMulti: true, placeholder: placeholder, onChange: (newValue, actionMeta) => onChange(newValue, actionMeta), onInputChange: (e) => onInputChange(e), options: options, styles: menuStyles, menuPlacement: menuPlacement, menuPortalTarget: document.body, value: value }), !!errors[name] &&
                _jsx(Error, { children: errors[name].message })] })));
});
export default MultiSelect;
